export enum DropZoneType {
  leftSidebar = 'leftSidebar',
  rightSidebar = 'rightSidebar',
  main = 'main',
  navigation = 'navigation',
  widgets = 'widgets',
  menu = 'menu',
}
